<template>
  <el-dialog class="customDialog regionPreview" :modal="false" :close-on-click-modal="false" :close-on-press-escape = 'false' :title="uiType===0?'新增区域':'编辑区域'" :visible.sync="isShow" @close="onClose">
    <el-form  :model="formInline" :rules="rules" ref="form" label-position="right">
      <el-form-item label="区域名称：" prop="name">
        <el-input class="form-item" v-model="formInline.name" placeholder="请输入20字以内" :maxlength="20" show-word-limit ></el-input>
      </el-form-item>
      <el-form-item label="所属父级：" prop="reginParent">
        <!-- <el-tree class="regin-parent" :data="regionData" :props="defaultProps" ref="regionTree" node-key="id" @current-change="reginParentChanged" @node-expand="nodeExpand" @node-collapse="nodeExpand">
          <span class="custom-tree-node" slot-scope="{ node }">
            <span>{{ node.label }}</span>
          </span>
        </el-tree> -->
        <a-directory-tree v-if="isHaveData" class="regin-parent" :defaultExpandedKeys="expandedKeys" :selectedKeys="[this.formInline.reginParent]" :showLine="true" :showIcon="false" :treeData="regionData" :replaceFields="defaultProps" @select="reginParentChanged">
        </a-directory-tree>
        <div class="select-parent" v-show="formInline.reginParent !== undefined">
          <span class="title">所属父级目录：</span>
          <span class="value">{{getParentPath()}}</span>
        </div>
      </el-form-item>
      <el-form-item label="是否为最小区域：" prop="isLeaf">
        <el-radio-group v-model="formInline.isLeaf" :disabled="id !== undefined">
          <el-radio label="false">否</el-radio>
          <el-radio label="true">是</el-radio>
        </el-radio-group>
        <span class="tips">最小区域才能绑定模型</span>
      </el-form-item>
      <el-form-item label="模型选择：" prop="tileId"  v-show="formInline.isLeaf==='true'">
        <el-select class="form-item" v-model="formInline.tileId" filterable  placeholder="请选择" clearable>
          <!-- <el-option label="区域一" value="shanghai"></el-option>
          <el-option label="区域二" value="beijing"></el-option> -->
          <el-option v-for="item in models" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注：" prop="notes">
        <el-input class="form-item" v-model="formInline.notes" type="textarea" :maxlength="255" show-word-limit placeholder="请输入" >
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="default" @click="onClose">取消</el-button>
      <el-button type="primary" :loading="loading" @click="onSubmit">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addArea, updateArea, getArealList, getArea } from '@/api/area'
import { getModelList } from '@/api/model'
import { searchBFS, treeForeach } from '@/utils/tree'
export default {
  name: 'RegionPreview',
  data () {
    // var validateTileId = (rule, value, callback) => {
    //   if (this.formInline.isLeaf === true && !value) {
    //     callback(new Error('请选择绑定模型'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      isShow: false,
      // ui类型，0新增，1修改
      uiType: 0,
      formInline: {
        name: '',
        reginParent: 0,
        isLeaf: 'false',
        tileId: undefined,
        notes: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入区域名称', trigger: 'blur' },
          { min: 1, max: 20, message: '请输入20字以内', trigger: 'blur' }
        ],
        reginParent: [
          { required: true, message: '请选择区域父级', trigger: 'blur' }
        ],
        isLeaf: [
          { required: true, message: '请选择是否为最小区域', trigger: 'blur' }
        ]
        // tileId: [
        //   { required: () => { return this.formInline.isLeaf === true }, message: '请选择区域模型', trigger: 'blur' }
        // ]
      },
      // 当前编辑区域id
      id: undefined,
      // 模型资源列表
      modelList: [],
      // 当前绑定模型
      bindModel: undefined,
      regionData: [{
        id: 0,
        name: '根节点',
        children: []
      }],
      defaultProps: {
        children: 'children',
        title: 'name',
        key: 'id'
        // disabled: 'disabled'
      },
      loading: false,
      expandedKeys: [],
      isHaveData: false
    }
  },
  mounted () {

  },
  computed: {
    models () {
      const model = []
      for (let i = 0; i < this.modelList.length; i++) {
        const item = this.modelList[i]
        model.push({
          id: item.id,
          name: item.name
        })
      }
      // if (this.bindModel && model.findIndex(item => { return item.id === this.bindModel.id }) < 0) {
      //   model.push({
      //     id: this.bindModel.id,
      //     name: this.bindModel.name
      //   })
      // }
      return model
    }
  },
  methods: {
    open (id) {
      this.isShow = true
      this.updateModelList()
      this.updateAreaList()
      if (id) {
        this.uiType = 1
        this.id = id
        this.getAreaInfo()
      } else {
        this.uiType = 0
        this.id = undefined
      }
    },
    // 限制树不可用
    disableItem (id) {
      const node = this.getNodeById(id)
      treeForeach([node], 'children', (item) => {
        item.disabled = true
      })
    },
    // 获取模型列表
    updateModelList () {
      getModelList().then(res => {
        this.modelList = res.data
      })
    },
    // 获取区域列表
    updateAreaList () {
      getArealList().then(res => {
        this.regionData[0].children = res.data
        treeForeach(this.regionData, 'children', (item) => {
          item.disabled = item.type === 'FINAL'
          this.expandedKeys.push(item.id)
        })
        this.isHaveData = true
        if (this.id) {
          this.disableItem(this.id)
        }
      }).catch(res => {
        this.isHaveData = true
      })
    },
    // 获取编辑区域信息
    getAreaInfo () {
      getArea({
        id: this.id
      }).then(res => {
        if (res.code === 200) {
          const options = res.data
          this.formInline.isLeaf = options.type === 'FINAL' ? 'true' : 'false'
          this.formInline.tileId = options.modelId
          this.formInline.name = options.name
          this.formInline.reginParent = options.parentId
          this.formInline.notes = options.remark
          if (options.model) {
            this.bindModel = {
              id: options.model.id,
              name: options.model.name
            }
          }
          if (this.isHaveData) {
            this.disableItem(this.id)
          }
        }
      })
    },
    reginParentChanged (selectedId) {
      this.formInline.reginParent = selectedId[0]
    },
    // 节点展开关闭事件
    nodeExpand (data, node, component) {
      this.$refs.regionTree.setCurrentKey(node.data.id)
      const selected = this.$refs.regionTree.getCurrentNode()
      this.formInline.reginParent = selected.id

      this.$refs.form.validate()
    },
    // 获取父节点路径
    getParentPath () {
      let path = ''
      if (this.formInline.reginParent !== undefined) {
        let node = this.getNodeById(this.formInline.reginParent)
        if (!node) {
          return path
        }
        path = node.name + '/' + path
        while (node.parentId !== undefined) {
          node = this.getNodeById(node.parentId)
          path = node.name + '/' + path
        }
      }
      return path
    },
    // 通过id获取node
    getNodeById (id) {
      const node = searchBFS(this.regionData, 'children', (item) => {
        return item.id === id
      })
      return node[0]
    },
    clear () {
      this.$refs.form.resetFields()
      this.modelList = []
      this.bindModel = undefined
      this.formInline = this.$options.data().formInline
      this.expandedKeys.splice(0, this.expandedKeys.length)
      this.regionData = [{
        id: 0,
        name: '根节点',
        children: []
      }]
      this.isHaveData = false
    },
    onClose () {
      this.clear()
      this.isShow = false
    },
    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          if (this.uiType === 0) {
            addArea({
              modelId: this.formInline.isLeaf === 'true' ? this.formInline.tileId : '',
              name: this.formInline.name,
              parentId: this.formInline.reginParent,
              remark: this.formInline.notes,
              type: this.formInline.isLeaf === 'true' ? 'FINAL' : 'COMMON'
            }).then(res => {
              if (res.code === 200) {
                this.$Message('success', '添加区域成功')
                this.$emit('refresh')
                this.onClose()
              }
              this.loading = false
            }).catch(res => {
              this.loading = false
            })
          } else {
            updateArea({
              id: this.id,
              modelId: this.formInline.tileId,
              name: this.formInline.name,
              parentId: this.formInline.reginParent,
              remark: this.formInline.notes,
              type: this.formInline.isLeaf === 'true' ? 'FINAL' : 'COMMON'
            }).then(res => {
              if (res.code === 200) {
                this.$Message('success', '修改区域成功')
                this.$emit('refresh')
                this.onClose()
              }
              this.loading = false
            }).catch(res => {
              this.loading = false
            })
          }
        } else {
          // this.$Message('error', '提交数据格式错误')
        }
      })
    }
  }
}
</script>

<style lang="scss">
.regionPreview{
  .el-form-item__error{
    margin-left: 140px;
  }
  .el-dialog{
    width: 500px;
    .el-form-item__label{
      width: 140px;
    }
  }
  .regin-parent{
    height: 260px;
    width: 260px;
    overflow-y: auto;
    background: rgba(255,255,255,0.1);
    border-radius: 7px;
    padding: 10px 10px;
    margin-left: -10px;
  }
  .ant-tree-title{
    color: #fff;
  }
  .ant-tree-node-content-wrapper{
    &:hover,
    &.ant-tree-node-selected{
      background: $hover-color !important;
      border-radius: 4px !important;
    }
  }
  .ant-tree.ant-tree-directory > li.ant-tree-treenode-selected > span.ant-tree-node-content-wrapper::before,
  .ant-tree.ant-tree-directory .ant-tree-child-tree > li.ant-tree-treenode-selected > span.ant-tree-node-content-wrapper::before{
    background: $hover-color;
    border-radius: 4px;
  }
  .ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper:hover::before,
  .ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-node-content-wrapper:hover::before{
    background: $hover-color;
    border-radius: 4px;
  }

  .ant-tree.ant-tree-show-line li{
    text-align: left;
  }
  .ant-tree.ant-tree-show-line li span.ant-tree-switcher{
    color: unset;
    background: unset;
    margin-left: 5px;
    margin-top: 5px;
    margin-right: -10px;
    &.ant-tree-switcher_close{
      background: url('../../../../assets/images/put.png') no-repeat;
      i {
        display: none;
      }
    }
    &.ant-tree-switcher_open{
      background: url('../../../../assets/images/open.png') no-repeat;
      i {
        display: none;
      }
    }
    &.ant-tree-switcher-noop {
      i {
        display: none;
      }
    }
  }

  .ant-tree.ant-tree-show-line  li:not(:first-child)::before{
    border-left: 1px dashed rgba(255,255,255,0.1);
    border-bottom: 1px dashed rgba(255,255,255,0.1);
    height: 100%;
    margin: 0 0 0;
    content: ' ';
    position: absolute;
    left: 12px;
    width: 10px;
    top: -15px;
  }
  .ant-tree.ant-tree-show-line  li:first-child::before{
    border-left: 1px dashed rgba(255,255,255,0.1);
    border-bottom: 1px dashed rgba(255,255,255,0.1);
    height: calc(100% - 22px);
    margin: 22px 0 0;
    content: ' ';
    position: absolute;
    left: 12px;
    width: 10px;
    top: -15px;
  }
  li.ant-tree-treenode-disabled > span:not(.ant-tree-switcher),
  li.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper,
  li.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper span{
    color: rgba(255,255,255,0.1);
  }

  .ant-tree li{
    padding: 0;
    .ant-tree-node-content-wrapper{
      transition: all 0.0s !important;
    }
  }
  .ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper::before,
  .ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-node-content-wrapper::before{
    transition: all 0.0s !important;
  }
  // .ant-tree-child-tree > li:first-child{
  //   padding: 0;
  // }

  .select-parent{
    margin-top: 10px;
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 4px;
    text-align: left;
    padding: 0px 10px;
    line-height: 2;
    width: 260px;
    margin-left: -10px;
    transform: translateX(150px);
    .title{
      color: $font-color9;
    }
    .value{
      color: $font-colorf;
    }
  }
  .el-radio-group{
    margin-left: -53px;
  }
  .tips{
    color: #F6313B;
    font-size: 12px;
    margin-left: 5px;
    background: url('../../../../assets/images/ts.svg') no-repeat;
    padding: 4px 19px 5px 19px;
    background-size: cover;
  }
  // .custom-tree-node{
  // }
  .form-item{
    width: 260px;
    margin-left: -59px;
  }
}
</style>
